import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const GeneralResultsChartsDataContext = createContext();

const GeneralResultsChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.GENERAL_RESULTS_RESULTS,
            url: 'governanceroom/dashboard/vitalstatistics/results/general-results'
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  liveBirthsWithAnomaly:
                      data?.indicators?.liveBirthsWithAnomaly ?? 0,
                  mothersLessThan6PrenatalConsultations:
                      data?.indicators?.mothersLessThan6PrenatalConsultations ??
                      0,
                  averageRegistrationTime:
                      data?.indicators?.averageRegistrationTime ?? 0,
                  weightIndex: data?.indicators?.weightIndex ?? 0,
                  tenagerMothers: data?.indicators?.tenagerMothers ?? 0,
                  averageTimeDeathCertificate:
                      data?.indicators?.averageTimeDeathCertificate ?? 0,
                  fetalDeaths: data?.indicators?.fetalDeaths ?? 0
              },
              typesOfBirth: data?.typesOfBirth ?? [],
              vitalStatistics: data?.vitalStatistics ?? [],
              populationBalance: data?.populationBalance ?? []
          }
        : {
              indicators: {
                  liveBirthsWithAnomaly: 0,
                  mothersLessThan6PrenatalConsultations: 0,
                  averageRegistrationTime: 0,
                  weightIndex: 0,
                  tenagerMothers: 0,
                  averageTimeDeathCertificate: 0,
                  fetalDeaths: 0
              },
              typesOfBirth: [],
              vitalStatistics: [],
              populationBalance: []
          };


    return (
        <GeneralResultsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </GeneralResultsChartsDataContext.Provider>
    );
};

export default GeneralResultsChartsDataProvider;
